
export const mockNextInformedDeliveryApis = {

    getRideAlong: async () => [
        {
            url: "https://picsum.photos/seed/358d/300/200",
        },
        {
            url: "https://picsum.photos/seed/aedcew/300/200",
        },
        {
            url: "https://picsum.photos/seed/65hg23/300/200",
        },
        {
            url: "https://picsum.photos/seed/329dj/300/200",
        },
        {
            url: "https://picsum.photos/seed/f454h5/300/200",
        },
        {
            url: "https://picsum.photos/seed/v23u76/300/200",
        },
    ],
    // getRideAlong: async () => ({
    //     "result": "failure",
    //     "errors": {
    //         "target": "getRideAlongImages",
    //         "msg": "Ride-along image not available"
    //     }
    // }),
};